import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { AnimatedStepBody } from '../animation/StepBodyAnimations';
import { getActiveLoading } from '../store/loading-status/selectors';
import { LoadingCentered } from './Loading.styles';
import { LoadingTitle } from './LoadingTitle';
// @ts-expect-error dependency missing types
import Confetti from 'growth-onboarding-shared-demo-components/transitions/Confetti';

const IllustrationLoadingView = ({
  loadingKey,
  hasSpinner = true,
  illustration,
  imageClass,
  textDisplayDelay = 0,
  hasConfetti = false
}) => {
  const [showSpinner, setShouldShowSpinner] = useState(true);
  const [shouldShowText, setShouldShowText] = useState(false);
  const titleToDisplay = `loading.${loadingKey}.title`;
  const shouldNotAnimate = Boolean(useSelector(getActiveLoading));

  const renderSpinner = () => {
    return (hasSpinner || showSpinner) && /*#__PURE__*/_jsx(UILoadingSpinner, {
      grow: true,
      minHeight: 100,
      size: "md"
    });
  };

  const renderIllustration = () => {
    return illustration && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(UIIllustration, {
        className: imageClass,
        name: illustration,
        onLoad: () => {
          setShouldShowSpinner(false);
        }
      })
    });
  };

  const renderText = () => {
    if ((illustration || showSpinner) && shouldShowText) {
      return /*#__PURE__*/_jsx("div", {
        children: isValidI18nKey(titleToDisplay) && /*#__PURE__*/_jsx(LoadingTitle, {
          title: titleToDisplay
        })
      });
    }

    return null;
  };

  useEffect(() => {
    const timeout = setTimeout(() => setShouldShowText(true), textDisplayDelay);
    return () => {
      clearTimeout(timeout);
    };
  }, [shouldShowText, textDisplayDelay]);
  return /*#__PURE__*/_jsxs(AnimatedStepBody, {
    disableAnimation: shouldNotAnimate,
    children: [hasConfetti && /*#__PURE__*/_jsx(Confetti, {}), /*#__PURE__*/_jsx(NavMarker, {
      name: "LOADING"
    }), /*#__PURE__*/_jsx("div", {
      "data-selenium": loadingKey,
      children: /*#__PURE__*/_jsxs(LoadingCentered, {
        children: [renderIllustration(), renderText(), renderSpinner()]
      })
    })]
  });
};

export default IllustrationLoadingView;